// Third Party
import cx from 'classnames';

export const getFormFieldStylesAsClassName = (
  messageContent?: React.ReactNode
): string => {
  return cx({ 'pb-2': !!messageContent });
};

export const getFormFieldMessageStylesAsClassName = (
  messageContent?: React.ReactNode
): string => {
  return cx('pb-2', { hidden: !messageContent });
};
